module.exports = __webpack_public_path__ + "img/logo.e5142d46.png";